export default __webpack_public_path__ + "static/media/octron_1.f5131617.jpg";